export default __webpack_public_path__ + "media/images/logo/media/mainichi-e9ab0c7cce8f3d2136c5184e63eda4e1.png";